import type { FunctionComponent } from "react";
import { Button } from "@kanda-libs/ks-design-library";
import useDownloadPdfButtonProps from "components/job/JobLayout/JobActions/DownloadPdfButton/useDownloadPdfButtonProps";

export interface DownloadPdfButtonProps {}

export const DownloadPdfButton: FunctionComponent<
  DownloadPdfButtonProps
> = () => {
  const { onClick, isSubmitting, status, isLoading } =
    useDownloadPdfButtonProps();

  return (
    <Button.Text
      id="staff-download-job-pdf"
      onClick={onClick}
      label="Download job PDF"
      size={40}
      className=""
      isLoading={isLoading}
      disabled={isSubmitting || (status && status === "draft") || false}
    />
  );
};

export default DownloadPdfButton;
